import AppConstants from 'constants/AppConstants';

interface State {
  consumerWidgetToken: string | undefined;
  isRequestInProgress: boolean;
}

const initialState: State = {
  consumerWidgetToken: undefined,
  isRequestInProgress: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.BUSINESS_CONSUMER_WIDGET_TOKEN_FETCH_STARTING: {
      return {
        ...state,
        isRequestInProgress: true,
      };
    }
    case AppConstants.BUSINESS_CONSUMER_WIDGET_TOKEN_FETCH_FAILED: {
      return {
        ...state,
        isRequestInProgress: false,
      };
    }
    case AppConstants.BUSINESS_CONSUMER_WIDGET_TOKEN_FETCH_DONE: {
      return {
        ...state,
        consumerWidgetToken: payload,
        isRequestInProgress: false,
      };
    }
    default:
      return state;
  }
}
